// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { change } from 'redux-form'

const assignRadioData = (radio, sourceForm) => dispatch => {
  if (radio) {
    dispatch(change(sourceForm, 'radioCode', radio.radioCode))
    dispatch(change(sourceForm, 'radioId', radio.radioId))
    dispatch(change(sourceForm, 'radioFavoriteId', radio.radioFavoriteId))
  } else {
    dispatch(change(sourceForm, 'radioCode', ''))
    dispatch(change(sourceForm, 'radioId', null))
    dispatch(change(sourceForm, 'radioFavoriteId', null))
  }
}

export default assignRadioData
